// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Component
export const IconLock = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 165.788 161.469"
    >
      <path
        fill="#0070f2"
        opacity="0.148"
        d="M89.573,0c35.294,0,38.238,8.062,38.238,42.285S94.593,94.327,63.905,104.253,0,76.509,0,42.285,54.279,0,89.573,0Z"
        transform="matrix(0.799, 0.602, -0.602, 0.799, 63.713, 0)"
      />
      <g transform="translate(35.817 31.264)">
        <g transform="translate(21.183 7.04)">
          <g transform="translate(6.795)">
            <path
              fill="#80baff"
              d="M187.525,70.719h-11V56.5a7.781,7.781,0,1,0-15.563,0V70.717h-11V56.5a18.781,18.781,0,1,1,37.561,0Z"
              transform="translate(-149.964 -37.724)"
            />
          </g>
          <g transform="translate(25.966 0.003)">
            <path
              fill="#6cabf7"
              d="M274.391,56.517V70.732h-11V56.517A7.789,7.789,0,0,0,256,48.747V37.74A18.8,18.8,0,0,1,274.391,56.517Z"
              transform="translate(-256 -37.74)"
            />
          </g>
          <g transform="translate(0 31.927)">
            <path
              fill="#0f7eff"
              d="M146.265,258.34H130.423a18.045,18.045,0,0,1-18.045-18.045V214.317h51.933v25.977A18.045,18.045,0,0,1,146.265,258.34Z"
              transform="translate(-112.378 -214.317)"
            />
          </g>
          <g transform="translate(25.966 31.928)">
            <path
              fill="#0056bf"
              d="M281.966,214.32V240.3a18.045,18.045,0,0,1-18.045,18.045H256V214.32Z"
              transform="translate(-256 -214.32)"
            />
          </g>
          <path
            fill="#fff"
            d="M233.42,281.94a6.728,6.728,0,0,0-.557-2.613,6.3,6.3,0,0,0-5.838-3.781,6.393,6.393,0,0,0-4.2,11.213l-1.674,10.67H232.9l-1.674-10.67A6.378,6.378,0,0,0,233.42,281.94Z"
            transform="translate(-201.058 -232.548)"
          />
          <path
            fill="#fff"
            d="M260.2,286.761l1.674,10.671H256V275.55a6.392,6.392,0,0,1,4.2,11.211Z"
            transform="translate(-230.034 -232.552)"
          />
        </g>
      </g>
    </svg>
  )
}

IconLock.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

IconLock.defaultProps = {
  width: '166px',
  height: '162px',
}

export default IconLock
